export default __webpack_public_path__ + "static/media/expose6.d5c9f698.png";